export { Title2, title2ClassNames } from './components/presets/Title2/index';
